import { useAuthenticatedQuery } from './useAuthenticatedQuery';
import { fetchPlanInstanceSummary, type PlanInstanceSummaryResponse } from '@/lib/templateApi';

export function usePlanInstanceSummary(instanceId: string | null) {
  return useAuthenticatedQuery<PlanInstanceSummaryResponse>({
    queryKey: ['plan-summary', instanceId],
    queryFn: () => fetchPlanInstanceSummary(instanceId!),
    enabled: !!instanceId,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
}
